import { render, staticRenderFns } from "./virtualAssistants.vue?vue&type=template&id=bac9491e&scoped=true"
import script from "./virtualAssistants.vue?vue&type=script&lang=js"
export * from "./virtualAssistants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac9491e",
  null
  
)

export default component.exports